import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import { actions as groupAction } from 'containers/Group';

import { routes as history } from './AttendanceHistory';
import { routes as mark } from './MarkAttendance';
import Attendance from './component';

export const path = 'attendance';

export default ({ getState }) => ({
  path,
  component: Attendance,
  canAccess: ({ params }) =>
    TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.MarkAttendance) &&
        groupAction.shouldEnableMarkAttendance(getState(), params.groupId, true),
  tab: {
    label: 'Attendance',
    order: 1,
    isVisible: (params) =>
      groupAction.shouldEnableMarkAttendance(getState(), params.groupId) &&
          TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.MarkAttendance) &&
          (PrivilegeChecker.hasPrivilege(getState(), Privileges.MarkAttendance.ViewDayView) ||
              PrivilegeChecker.hasPrivilege(getState(), Privileges.MarkAttendance.ViewCourseView)),
    query: () =>  // redirect to the course view in `onEnter` if we are currently in one
      (location.pathname.endsWith('/course') ? 'course' : null),
  },
  breadcrumbLabels: 'Attendance',
  childRoutes: [
    history,
    mark,
  ],
});



// WEBPACK FOOTER //
// ./containers/Group/Attendance/routes.js